module.exports = __webpack_public_path__ + "static/favicon-35abe781c1e5520e7a661a258b3d41cb.ico";